import { colors } from "constants/colors";
import styled, { css } from "styled-components";

export type StyledSpeachBalloonProps = {
  background?: string;
  border?: boolean;
  borderRadius?: string;
};

export const StyledSpeachBalloon = styled.div<StyledSpeachBalloonProps>`
  display: inline-block;
  width: fit-content;
  padding: 8px 12px;

  ${({ borderRadius }) =>
    css`
      border-radius: ${borderRadius || "2rem"};
    `}

  ${({ background }) =>
    css`
      background-color: ${background};
    `};
  ${({ border }) =>
    border &&
    css`
      border: solid 1px;
      border-color: ${colors.dimgray};
    `};
`;
